import React from 'react';
import {observer} from 'mobx-react';
import {Switch, Route, Redirect} from 'react-router-dom';
import PendingRequestsList from './PendingRequestsList';

const PendingRequestPage = observer(({match, scope}) => {
  return (
    <Switch>
      <Route exact path={match.path} render={({history, match}) => <PendingRequestsList match={match} history={history} scope={scope}/>} />
      <Route path={`${match.path}/:id`} render={({match, location}) => <Redirect to={`/requests/${match.params.id}${location.search}`}/>}/>
    </Switch>
  );
});

export default PendingRequestPage;
